import React from "react";
const Col = (props) => {
  return (
    <div className={`col-${props.model}-${props.size} ${props.className} ${props.margin}`}>
      {props.children}
    </div>
  );
};

Col.defaultProps = {
  size: 4,
  className: "",
  model: "md",
  margin: "mb-1"
}

export default Col;